const msg = {
    confirm: "此操作将永久删除数据，是否继续?",
    tip: "提示",
    confirmText1: "确定",
    confirmText2: "取消",
    deleted: "删除成功!",
    delete_fail: "删除失败!",
    undelete: "已取消删除!",
    submit: "新增成功!",
    submit2: "编辑成功!",
    submit3: "操作成功!",
    submit4: "删除成功!",
    submit5: "新增失败!",
    submit6: "编辑失败!",
    submit7: "操作失败!",
    submit8: "删除失败!"
};

export default msg;
